///
/// EarthBrowser
///
/// Earthquake Browser Feature
///
/// Manages earthquake browser window lifecycle and command palette registration
///
/// Created by Matt Giger on December 19, 2025
/// Copyright (c) 2025 Geodata Labs
///

import { useEffect } from 'react'
import { Activity } from 'lucide-react'
import { EarthquakeBrowserRenderer } from '@/components/features/earthquake-browser/EarthquakeBrowser'
import { CommandRegistry } from '@/components/features/CommandRegistry'
import { useAppDispatch, useAppSelector } from '@/redux/store'
import { openOrRestoreWindow } from '@/utils/windowUtils'

const EARTHQUAKE_WINDOW_ID = 'earthquake-browser'
const EARTHQUAKE_WINDOW_WIDTH = 700
const EARTHQUAKE_WINDOW_HEIGHT = 500

export function EarthquakeBrowserFeature() {
	const dispatch = useAppDispatch()
	const datasetWindows = useAppSelector(state => state.dialog.datasetWindows)
	const earthquakeWindow = datasetWindows[EARTHQUAKE_WINDOW_ID]

	// Register with command palette
	useEffect(() => {
		const unregister = CommandRegistry.registerFeature({
			id: 'earthquake-browser',
			command: {
				id: 'earthquakes',
				title: 'Earthquakes',
				icon: <Activity className="w-4 h-4 text-red-500" />,
				category: 'Datasets',
				enabled: true,
			onSelect: () => {
				openOrRestoreWindow(
					dispatch,
					datasetWindows,
					EARTHQUAKE_WINDOW_ID,
					{
						id: EARTHQUAKE_WINDOW_ID,
						title: 'Earthquakes',
						windowType: 'earthquake',
						x: 100,
						y: 100,
						width: EARTHQUAKE_WINDOW_WIDTH,
						height: EARTHQUAKE_WINDOW_HEIGHT,
						isMaximized: false,
						isVisible: true,
					}
				)
			}
			},
			renderBrowser: () => null // Not needed for window-based browser
		})

		return unregister
	}, [dispatch, datasetWindows])

	// Render the window if it's open
	if (!earthquakeWindow) {
		return null
	}

	return (
		<EarthquakeBrowserRenderer
			windowId={EARTHQUAKE_WINDOW_ID}
			windowState={earthquakeWindow}
		/>
	)
}
